import type { TOC } from '@ember/component/template-only'
import { hash } from '@ember/helper'
import { LinkTo } from '@ember/routing'
import { or } from 'ember-truth-helpers'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'
import { type TeacherResourceCategoryEntry } from 'teacher-ui-client/contentful-client/entry-types'
import { getId } from 'teacher-ui-client/contentful-client/entry-types'

interface Signature {
  Element: HTMLDivElement
  Args: {
    category: TeacherResourceCategoryEntry
  }
}

export const TeacherToolkitCategoryHeader: TOC<Signature> = <template>
  <div class="border-dusty-black-50 flex items-center border-b-2" ...attributes>
    {{! If it has subcategories, link to the next page }}
    {{#if (or @category.fields.categories @category.fields.resources)}}
      <LinkTo
        @query={{hash category=@category.fields.path}}
        class="text-dusty-black-300 hover:text-oceany-blue-300 focus:text-oceany-blue-300 text-2xl font-semibold"
      >
        {{@category.fields.name}}
      </LinkTo>
    {{else}}
      <h3 class="text-dusty-black-300">
        {{@category.fields.name}}
      </h3>
    {{/if}}
    <ContentfulEdit @entryId={{getId @category}} class="ml-4" />
  </div>
</template>
